import { Component, Input } from '@angular/core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { ListItem } from '@rensa/modules/customer/models/list-item.model';
import { environment } from '@rensa/environments/environment';
import { ItemType } from '@rensa/shared/enums/item-type.enum';

@Component({
    selector: 'app-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.css'],
})
export class ListItemComponent {
    @Input() listItem: ListItem;
    faArrowRight = faArrowRight;

    constructor(private router: Router) {}

    navigateToDetail(): void {
        this.router.navigate([`${ItemType[this.listItem.itemType].toLowerCase()}/detail`, this.listItem.id]);
    }

    getSendToUri(listItemId: string | undefined, listItemTitle: string | undefined): string {
        const subject = environment.sendToEmail[environment.itemType].subject;
        const body = environment.sendToEmail[environment.itemType].itemOverview.body
            .replace('{{title}}', listItemTitle)
            .replace('{{link}}', `${environment.frontendUrl}/${listItemId}`);
        return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }

    getItemTypeAsTring(): string {
        if (this.listItem?.itemType == null)
        {
            return "training";
        }
        
        return  this.listItem.itemType === ItemType.KennisCafe ? "kenniscafé" : "training";
    }
}
